<div class="app-container">
  <app-command-palette></app-command-palette>
  <!-- Sidebar nur hier -->
  <app-header class="block md:hidden"></app-header>
  <app-sidebar class="hidden md:block"></app-sidebar>
  <main class="main-content mt-[70px] md:mt-0">
    <router-outlet></router-outlet>
    <!-- Inhalte der Unterseiten -->
  </main>
</div>
